import { isRequestCancelled } from "../../classes/utils/RequestUtils";
import apiClient from "../../clients/apiClient";
import API_ENDPOINTS from "../../config/apiEndpointsConfig";

//Profile picture

export const getPatientProfilePictureEndpoint = async patientId => {
  return apiClient
    .get(`${API_ENDPOINTS.GET_PATIENT_PROFILE_PICTURE(patientId)}`, {
      responseType: "blob",
    })
    .then(response => {
      return { data: response.data, contentType: response.data.contentType };
    })
    .catch(error => {
      throw new Error(`Error fetching the images: ${error.message}`);
    });
};

// Morphology pictures

export const getPatientMorphologyPictureEndpoint = async (
  patientId,
  filename,
  signal
) => {
  return apiClient
    .get(
      `${API_ENDPOINTS.GET_PATIENT_MORPHOLOGY_PICTURE(patientId, filename)}`,
      {
        responseType: "blob",
        signal,
      }
    )
    .then(response => {
      return { data: response.data, contentType: response.data.contentType };
    })
    .catch(error => {
      if (isRequestCancelled(error)) throw error;
      throw new Error(`Error fetching the images: ${error.message}`);
    });
};

export const getPatientMorphologyPicturesListEndpoint = async (
  patientId,
  signal
) => {
  return apiClient
    .get(`${API_ENDPOINTS.GET_PATIENT_MORPHOLOGY_PICTURES_LIST(patientId)}`, {
      responseType: "json",
      signal,
    })
    .then(response => {
      return { data: response.data, contentType: response.data.contentType };
    })
    .catch(error => {
      if (isRequestCancelled(error)) throw error;
      // If patient has no morphology images, return empty array instead of error
      if (error.response?.status === 404) {
        return { data: [], contentType: null };
      }
      throw new Error(
        `Error fetching the morphology images list: ${error.message}`
      );
    });
};

export const postPatientMorphologyPictureEndpoint = async (
  patientId,
  imageFile,
  filename
) => {
  const formData = new FormData();
  formData.append("image", imageFile.file);
  return apiClient
    .post(
      `${API_ENDPOINTS.POST_PATIENT_MORPHOLOGY_PICTURE(patientId, filename)}`,
      formData
    )
    .then(response => {
      return response.data;
    })
    .catch(error => {
      throw new Error(`Error fetching the images: ${error.message}`);
    });
};

export const uploadAnnexeImageEndpoint = async (
  patientId,
  digitalTwinId,
  blob,
  fileName
) => {
  const formData = new FormData();
  formData.append("image", blob, fileName);
  return apiClient
    .post(
      API_ENDPOINTS.POST_DIGITAL_TWIN_ANNEXE_IMAGE(patientId, digitalTwinId),
      formData
    )
    .then(response => response.data)
    .catch(error => {
      throw new Error(`Error uploading annexe image: ${error.message}`);
    });
};

export const deletePatientMorphologyPictureEndpoint = async (
  patientId,
  filename
) => {
  const endpoint = API_ENDPOINTS.DELETE_MORPHOLOGY_IMAGE(patientId, filename);
  try {
    const response = await apiClient.delete(endpoint);
    return response.data;
  } catch (error) {
    const errorMessage =
      error?.response?.data?.detail ||
      error?.response?.data?.error ||
      error.message;
    throw new Error(`${errorMessage}`);
  }
};
